import { setValue, updateIn } from "../../lib/immutable_wrapper";
import {
    GET_EQUIPMENTSEPI,
    GET_COWORKERS_EQUIPMENTSEPI,
    GET_COMMON_AND_UNAFFECTED_EQUIPMENTS,
    SET_EPI_FILTERS,
    SET_CURRENT_EQUIPMENTEPI,
    SET_CURRENT_EQUIPMENTEPI_FORM,
    SET_CURRENT_EQUIPMENT_INPSECTION,
    SET_EQUIPMENTEPI_FORM_SECTIONS,
    SET_EQUIPMENTS_EPI_TAB_ID,
    SET_EQUIPMENTS_EPI_INDEX,
    SET_EPI_FILTERED_LIST,
    SET_NB_EPI_TO_CHECK,
    SET_EPICATEGORIES,
} from "./equipmentsEPIConstants";
import { ALL_SELECT_OPTION } from "../../constants";

export function getDefaultEPIFilters() {
    return {
        employees: [ALL_SELECT_OPTION],
        departments: [ALL_SELECT_OPTION],
        categories: [ALL_SELECT_OPTION],
        models: [ALL_SELECT_OPTION],
        brands: [ALL_SELECT_OPTION],
        serialNumbers: [ALL_SELECT_OPTION],
        equipmentTypes: [ALL_SELECT_OPTION],
    };
}

const initialState = {
    myEquipmentsEPI: [],
    coworkersEquipmentsEPI: [],
    commonAndUnaffectedEquipments: [],
    filteredEquipmentsEPI: [],
    epiCategories: [],
    epiFilters: {
        MY_EQUIPMENTS_EPI: getDefaultEPIFilters(),
        COWORKERS_EQUIPMENTS_EPI: getDefaultEPIFilters(),
    },
    tabId: 0,
    epiIndex: 0,
    nbEPIToCheck: 0,
};

const equipmentEPIInitialState = {
    currentEquipmentEPI: null,
    currentEquipmentInspection: null,
    currentEquipmentEPIForm: null,
    equipmentEPIFormSections: [],
};

export function equipmentsEPI(state = initialState, action) {
    switch (action.type) {
        case GET_EQUIPMENTSEPI:
            return setValue(state, ["myEquipmentsEPI"], action.equipmentsEPI);
        case GET_COWORKERS_EQUIPMENTSEPI:
            return setValue(state, ["coworkersEquipmentsEPI"], action.equipmentsEPI);
        case GET_COMMON_AND_UNAFFECTED_EQUIPMENTS:
            return setValue(state, ["commonAndUnaffectedEquipments"], action.commonAndUnaffectedEquipments);
        case SET_EPI_FILTERS:
            return updateIn(state, ["epiFilters", action.filtersInstance], () => action.filters);
        case SET_EPI_FILTERED_LIST:
            return setValue(state, ["filteredEquipmentsEPI"], action.filteredEquipmentsEPI);
        case SET_EQUIPMENTS_EPI_TAB_ID:
            return setValue(state, ["tabId"], action.tabId);
        case SET_EQUIPMENTS_EPI_INDEX:
            return setValue(state, ["epiIndex"], action.epiIndex);
        case SET_NB_EPI_TO_CHECK:
            return setValue(state, ["nbEPIToCheck"], action.nbEPIToCheck);
        case SET_EPICATEGORIES:
            return setValue(state, ["epiCategories"], action.epiCategories);
        default:
            return state;
    }
}

export function equipmentEPI(state = equipmentEPIInitialState, action) {
    switch (action.type) {
        case SET_CURRENT_EQUIPMENTEPI:
            return setValue(state, ["currentEquipmentEPI"], action.currentEquipmentEPI);
        case SET_CURRENT_EQUIPMENT_INPSECTION:
            return setValue(state, ["currentEquipmentInspection"], action.currentEquipmentInspection);
        case SET_CURRENT_EQUIPMENTEPI_FORM:
            return setValue(state, ["currentEquipmentEPIForm"], action.currentEquipmentEPIForm);
        case SET_EQUIPMENTEPI_FORM_SECTIONS:
            return setValue(state, ["equipmentEPIFormSections"], action.equipmentEPIFormSections);
        default:
            return state;
    }
}
